"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  type: '',
  value: '',
  customerDetails: [],
  isFetchingData: false,
  showDialog: false,
  impersonationToken: '',
  error: null,
  showResult: false
};
exports.default = _default;